<template>
  <modal name="asyncModal" @closed="close">
    <div class="modal">
      <div>
        <slot />
      </div>
      <button class="close-modal button" @click="close">
        {{ texts.close }}
      </button>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'asyncModal',
  data() {
    return {
      resolve: null,
      reject: null,
    };
  },
  computed: {
    texts() {
      return {
        close: this.$t('Close'),
      };
    },
  },
  methods: {
    open() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.$modal.show('asyncModal');
      });
    },

    close() {
      this.resolve(true);
      this.$emit('close');
      this.$modal.hide('asyncModal');
    },
  },
};
</script>

<style scoped lang="scss">
.modal {
  position: relative;
  display: flex;
  justify-content: center;
  flex-flow: column;
  text-align: center;
  font-size: 18px;
  height: 100%;
  padding: 30px;

  .close-modal {
    width: 30%;
    padding: 5px;
    align-self: center;
    margin-top: 48px;
  }
}
</style>
